<template>
  <v-dialog
    max-width="768"
    v-bind="$attrs"
    v-on="$listeners">
    <template v-slot:activator="{ on, attrs }">
      <slot
        :on="on"
        :attrs="attrs"
      />
    </template>
    <v-card>
      <img
        width="100%"
        :src="mapIconType"
        alt="Basic ID Instruction"
        loading="lazy" />

      <div class="py-2 text-center">
        <v-btn
          color="primary"
          outlined
          rounded
          width="150px"
          @click="$emit('input', false)">
          ปิด
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseBasicIdInstructionDialog',
  props: {
    type: {
      type: String,
      default: 'pc'
    }
  },
  computed: {
    mapIconType () {
      if (this.type === 'mobile') {
        return '/img/account/basic-id-instruction-mobile.jpg'
      }

      return '/img/account/basic-id-instruction-pc.jpg'
    }
  }
}
</script>
